import { render, staticRenderFns } from "./BatchEditRoomPrice.vue?vue&type=template&id=9fbe2206&scoped=true&"
import script from "./BatchEditRoomPrice.vue?vue&type=script&lang=js&"
export * from "./BatchEditRoomPrice.vue?vue&type=script&lang=js&"
import style0 from "./BatchEditRoomPrice.vue?vue&type=style&index=0&id=9fbe2206&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbe2206",
  null
  
)

export default component.exports